import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Conference } from "./components/conference";
import { useEffect } from "react";
import * as Sentry from "@sentry/react";

export const conference = {
  _room: null,
  get membersCount() {
    return this._room?.getParticipants().length + 1;
  },
  getConnectionState() {
    return this._room && this._room?.getConnectionState();
  },
  getStats() {
    return this._room && this._room?.connectionQuality.getStats();
  },
};
window.APP = {
  conference,
};

const App = () => {

  useEffect(() => {
    try {
      Sentry.init({
        dsn: 'https://767af35a7d8bae1dc0c924929a4e76d3@o479775.ingest.us.sentry.io/4509444907663360',
        _experiments: { enableLogs: true },
        tracesSampleRate: 1.0,     // optional, for performance monitoring
      });
      console.log('Sentry initialized');
    } catch (e) {
      console.error('Sentry init failed:', e);
    }
  }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:room" element={<Conference />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
